import uaNum from './uaJudgment.js';

/**
 * サンプルクラス
 * @constructor
 */
 class ClickAdd {

  constructor() {

    this._addClassNameVal = 'is-active';
    this._uaNum = uaNum;

    this.init();
  }
  /**
 * サンプル
 */
  init() {
    if (document.querySelector('.js-clickAdd--c1')) {
      this.hoverAddClass01('.js-clickAdd--c1','.l-drawer');
      if (this._uaNum === 1) { //SPだった場合
        this.hoverAddClass01('.js-clickAdd--c1Entry','.l-navMenu__item--entrySubBox');
      }
    }
    if (document.querySelector('.js-clickAdd--tab')) {
      // this.hoverAddClass01('.js-clickAdd--c1','.l-drawer');
    }
    if (this._uaNum === 1) { //SPだった場合
      this.hoverAddClass02('.js-clickAdd--c2','.l-drawer');
    }
  }

  // デフォルト click対象を指定して、自身にclass名をつける
  hoverAddClass (hoverTarget) {
    const targetItem = document.querySelectorAll(hoverTarget);
    targetItem.forEach(el => {
      el.addEventListener('mouseover', () => {
        el.classList.add(this._addClassNameval);
      });
      el.addEventListener('mouseleave', () => {
        el.classList.remove(this._addClassNameval);
      });
    });
  }

  // case01 click対象を指定して、class名を指定のDOMにつける
  // 基本的にclassを付与する対象は1つです
  hoverAddClass01(clickTarget, classAddTarget) {
    const targetItem = document.querySelectorAll(clickTarget);
    const elem = document.querySelector(classAddTarget);

    // ドロワーが非表示かどうかを追跡するためのフラグを初期化します。
    let isDrawerHidden = false;

    // 各ターゲットアイテムに対してクリックイベントリスナーを追加します。
    targetItem.forEach(el => {
      el.addEventListener('click', () => {
        // 要素が 'is-active' クラスを持っているかどうかを確認します。
        if (elem.classList.contains('is-active')) {
          // 要素から指定されたクラスを削除します。
          elem.classList.remove(this._addClassNameVal);
          // classAddTarget が '.l-drawer' であるかどうかをチェックします。
          if (classAddTarget === '.l-drawer') {
            drawerAct();
          }
        } else {
          // 要素に指定されたクラスを追加します。
          elem.classList.add(this._addClassNameVal);
          // classAddTarget が '.l-drawer' であるかどうかをチェックします。
          if (classAddTarget === '.l-drawer') {
            drawerAct();
          }
        }
      });
    });

    function drawerAct() {
      // isDrawerHidden フラグに基づいて body のオーバーフローを切り替えます。
      document.body.style.overflow = (isDrawerHidden) ? '' : 'hidden';
      // isDrawerHidden フラグを切り替えます。
      isDrawerHidden = !isDrawerHidden;
    }
  }

  hoverAddClass02(clickTarget, classAddTarget) {
    const targetItem = document.querySelectorAll(clickTarget);
    const elem = document.querySelector(classAddTarget);

    // ドロワーが非表示かどうかを追跡するためのフラグを初期化します。
    let isDrawerHidden = false;

    // 各ターゲットアイテムに対してクリックイベントリスナーを追加します。
    targetItem.forEach(el => {
      el.addEventListener('click', () => {
        // 要素が 'is-active' クラスを持っているかどうかを確認します。
        if (elem.classList.contains('is-active')) {
          // 要素から指定されたクラスを削除します。
          elem.classList.remove(this._addClassNameVal);
          // classAddTarget が '.l-drawer' であるかどうかをチェックします。
          if (classAddTarget === '.l-drawer') {
            drawerAct();
          }
        } else {
          // 要素に指定されたクラスを追加します。
          elem.classList.add(this._addClassNameVal);
          // classAddTarget が '.l-drawer' であるかどうかをチェックします。
          if (classAddTarget === '.l-drawer') {
            drawerAct();
          }
        }
      });
    });

    function drawerAct() {
      // isDrawerHidden フラグに基づいて body のオーバーフローを切り替えます。
      document.body.style.overflow = (isDrawerHidden) ? '' : 'hidden';
      // isDrawerHidden フラグを切り替えます。
      isDrawerHidden = !isDrawerHidden;
    }
  }
}

export default ClickAdd;
